import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './ktostamm-kunde.master-view.html',
    styleUrls: ['./ktostamm-kunde.master-view.scss']
})
export class KtostammKundeMasterView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
